module.exports = __webpack_public_path__ + "img/angle-right.dae452ae.svg";